import { useMutation, useQueryClient } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useDocumentCache } from 'entities/document/api/hooks/use-document-cache';
import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { patchDocumentsArchive } from '../requests';
import type { PatchDocumentsArchiveRequestType } from '../types';

export type PostDocumentArchiveMutationType = Omit<
  PatchDocumentsArchiveRequestType,
  'boardId'
> & {
  boardId?: PatchDocumentsArchiveRequestType['boardId'];
};

export const usePatchDocumentsArchive = () => {
  const queryClient = useQueryClient();
  const currentBoardId = useGetCurrentBoardId();
  const { refetchAllDocumentsQueries } = useDocumentCache();

  const onSuccess = async (_: any, { ids }: any) => {
    const queries = queryClient.getQueriesData({});

    // refetch all documents queries
    queries.forEach((query: any) => {
      if (query[0][0] === API_QUERY_KEYS.documents) {
        queryClient.refetchQueries(query[0]);
      }
    });

    // Optimistically update the cache for each archived document
    ids.forEach((documentId: number) => {
      queryClient.setQueryData(
        [API_QUERY_KEYS.document, { documentId }],
        (oldData: any) => ({
          ...oldData,
          archived: true,
        }),
      );
    });

    refetchAllDocumentsQueries();
  };

  return useMutation({
    mutationFn: (data: PostDocumentArchiveMutationType) =>
      patchDocumentsArchive({
        ...data,
        boardId: data.boardId || currentBoardId!,
      }),
    onSuccess,
  });
};
